import React, { useContext } from 'react';
import { styled } from '@mui/material/styles';

import { Typography } from '@mui/material';

import ModalDialog from 'components/ModalDialog/ModalDialog';
import { AppContext } from 'AppContext';

const PREFIX = 'ChangeTariffStandart';

const classes = {
  row: `${PREFIX}-row`,
  label: `${PREFIX}-label`,
};

const StyledModalDialog = styled(ModalDialog)(({ theme }) => ({
  [`& .${classes.row}`]: {
    display: 'flex',
    alignItems: 'center',
  },

  [`& .${classes.label}`]: {
    flexBasis: '50%',
    fontSize: 15,
  },
}));

const ChangeTariffStandart = ({ accountId, price }) => {
  const appContext = useContext(AppContext);

  const handleOk = () => {
    const origin = window.location.origin;
    appContext.tBankPaymentApi
      .tbankBuyPlan(accountId, {
        planId: 'standart_30d',
        successUrl: `${origin}/app/profile/account?payment=success`,
        failUrl: `${origin}/app/profile/account?payment=fail`,
      })
      .then(res => {
        window.location.href = res.data.paymentUrl;
      })
      .catch(appContext.errorHandler);
  };

  return (
    <StyledModalDialog
      size='sm'
      handleClose={() => appContext.history.push('/profile/account')}
      title={'Подключение Стандартного тарифа'}
      handleOk={() => handleOk()}
      okButtonText={'Оплатить'}
    >
      <>
        <Typography style={{ textAlign: 'center', marginBottom: 20 }}>
          После оплаты ежемесячного платежа станут доступны все опции тарифа.
        </Typography>
        <div className={classes.row} style={{ marginBottom: 20 }}>
          <Typography className={classes.label} style={{ fontWeight: 'bold' }}>
            Стоимость
          </Typography>
          <Typography className={classes.label} style={{ fontWeight: 'bold' }}>
            {price} руб.
          </Typography>
        </div>
      </>
    </StyledModalDialog>
  );
};

export default ChangeTariffStandart;
